module.exports = __webpack_public_path__ + "od-delivery-truck/od-delivery-truck-eeee043fe885653b673e1e7452270447.svg";